// extracted by mini-css-extract-plugin
module.exports = {"Email":"ContentBlueForm__Email_2XoTg"};